import { useMemo } from "react";
import { useSelector } from "react-redux";
import { getAccountPortfolio } from "../Account/accountSelectors";

export const useCashierWithdrawalAmount = () => {
    const portfolio = useSelector(getAccountPortfolio);

    return useMemo(() => {
        const credit = portfolio?.credit || 0;
        const marginFree = portfolio?.marginFree || 0;
        const amount = marginFree - credit;
        return amount < 0 ? 0 : amount;
    }, [portfolio]);
}
